import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgZone, ViewChild } from '@angular/core';
import { AlertController, IonPopover } from '@ionic/angular/standalone';
import { Store } from '@ngrx/store';
import { enterFadeOnly } from 'src/app/animations/common.animations';
import { ChipComponent } from 'src/app/components/chip/chip.component';
import { ItemLabelComponent } from 'src/app/components/item-label/item-label.component';
import { ItemNoteComponent } from 'src/app/components/item-note/item-note.component';
import { ItemComponent } from 'src/app/components/item/item.component';
import { SvgIconComponent } from 'src/app/components/svg-icon/svg-icon.component';
import { IsoDateToRelativePipe, TimeDisplay } from 'src/app/pipes/iso-date-to-relative.pipe';
import { UserInitialsPipe } from 'src/app/pipes/user-initials.pipe';
import { attachmentDownloadInitiated, removeAttachmentRequested } from 'src/app/store/patient-clinical-note/patient-clinical-note.actions';
import { CombinedClinicalNoteAttachment } from 'src/app/store/patient-clinical-note/patient-clinical-note.selectors';
import { AppState } from 'src/app/store/reducers';

@Component({
	selector: 'app-combined-attachment',
	templateUrl: './combined-attachment.component.html',
	styleUrl: './combined-attachment.component.scss',
	imports: [
		ChipComponent, DecimalPipe, UserInitialsPipe, IonPopover, ItemComponent, ItemLabelComponent, ItemNoteComponent, IsoDateToRelativePipe, SvgIconComponent
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [enterFadeOnly]
})
export class CombinedAttachmentComponent {

	TimeDisplay = TimeDisplay;

	@Input() combinedAttachment!: CombinedClinicalNoteAttachment;
	@Input() isReadOnly!: boolean;

	constructor(private alertController: AlertController, private ngZone: NgZone, private store: Store<AppState>) {
	}

	// #region Popover Logic

	popoverIsOpen: boolean = false;
	@ViewChild('popover') popover!: IonPopover;

	handleUserClick(event: Event) {
		event.stopPropagation();
		this.popover.event = event;
		this.popoverIsOpen = true;
	}

	// #endregion

	async removeAttachment() {
		const alert = await this.alertController.create({
			message: 'Are you sure you want to remove this attachment?',
			buttons: [
				'Cancel',
				{
					text: 'Remove',
					cssClass: 'button-critical',
					handler: () => {
						this.ngZone.run(() => this.store.dispatch(removeAttachmentRequested({ id: this.combinedAttachment.id })));
						alert.dismiss(true);
						return false;
					}
				}
			],
			backdropDismiss: false
		});
		alert.present();
	}

	downloadAttachment() {
		this.store.dispatch(attachmentDownloadInitiated({ id: this.combinedAttachment.id }));
	}
}